"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = exports.FormLabel = void 0;
var react_1 = __importDefault(require("react"));
var i18n_1 = require("../../i18n");
var styles_1 = require("../../styles");
function FormLabel(props) {
    var label = props.label, required = props.required, style = props.style, markerStyle = props.markerStyle, rest = __rest(props, ["label", "required", "style", "markerStyle"]);
    var _a = styles_1.useStyles(exports.createStyles), classes = _a.classes, css = _a.css;
    var locale = i18n_1.useLocale();
    return (react_1.default.createElement("label", __assign({ className: css(classes.label, style) }, rest),
        label,
        required && (react_1.default.createElement("span", { title: locale.formControl.required, className: css(classes.marker, markerStyle) }, "*"))));
}
exports.FormLabel = FormLabel;
exports.createStyles = function (theme) { return ({
    label: {
        fontWeight: 'bold',
    },
    marker: {
        color: theme.pallete.status.danger.main,
        marginLeft: '0.25rem',
    },
}); };
//# sourceMappingURL=FormLabel.js.map